// Stagger innerblock children for blocks with data-animate
document.querySelectorAll('[data-animate]').forEach(block => {
    const type     = block.dataset.animate;
    const container = block.querySelector('.acf-innerblocks-container');
    if ( !container ) return;

    Array.from(container.children).forEach((child, i) => {
        child.classList.add('animate', type, `delay-${i + 1}`);
    });
});

// Animate on scroll
const animations = document.querySelectorAll('.animate');
const observedClass = 'in-view';
const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
        const index = Array.from(animations).indexOf(entry.target);
        if (entry.isIntersecting) {
            animations[index].classList.add(observedClass);
        }
    })
}, {
    threshold: 0
});

// Start the observer
animations.forEach(animation => {
    observer.observe(animation);
});